var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarkerPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 18.3337C10.8333 14.167 16.6666 13.6822 16.6666 8.33366C16.6666 4.65176 13.6819 1.66699 9.99998 1.66699C6.31808 1.66699 3.33331 4.65176 3.33331 8.33366C3.33331 13.6822 9.16665 14.167 9.99998 18.3337Z",
    stroke: "#32AFB5",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 10.8337C11.3807 10.8337 12.5 9.71437 12.5 8.33366C12.5 6.95295 11.3807 5.83366 9.99998 5.83366C8.61927 5.83366 7.49998 6.95295 7.49998 8.33366C7.49998 9.71437 8.61927 10.8337 9.99998 10.8337Z",
    stroke: "#32AFB5",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPin);
export default __webpack_public_path__ + "static/media/marker-pin.fb98eaf7a2b3226b3dc747148ed97c27.svg";
export { ForwardRef as ReactComponent };